import React, { useState, useEffect } from 'react';
import '../choose-plan/plan.scss';
import './clarity.scss';
import Input from 'b2b-ui-components-lib/lib/components/input';
import Button from 'b2b-ui-components-lib/lib/components/button';
import TextArea from 'b2b-ui-components-lib/lib/components/textarea';
import Warning from '../../../assests/svg/warning.svg';
import { getClarityHistory } from '../../../common/helper/api.helper';
import moment from 'moment';
import { numberWithCommas } from '../../../common/utils/app.utils';
import { LEAD_STATUS, LEAD_STATUS_MSG } from '../../../home/common/constants/constants';
import { faOnDedicatedKamApprovalOrder } from '../../services/analytics.service';
import { contractPeriodOptions } from 'common/constants/app.constants';
import Select from 'b2b-ui-components-lib/lib/components/select';
import { getDoaDetailsNotification } from 'home/view/check-feasibility/comp-generator/component.generator';

const CustomizedPlan = ({
  selectedContractPeriod,
  selectedPlan,
  pnqPayload,
  doaStatus,
  arc,
  setarc,
  otc,
  setotc,
  doaId,
  fileArray,
  setfileArray,
  remarks,
  setremarks,
  setRemarksError,
  remarksError,
  setContractPeriod
}) => {
  const [commenthistory, setcommenthistory] = useState([]);
  const [fileName, setfileName] = useState('');
  const [showcomment, setshowcomment] = useState(false);
  const [showcommenthistory, setshowcommenthistory] = useState(false);
  const [fileuploadError, setfileuploadError] = useState(false);
  const [approvalRequestSentMsg, setApprovalRequestSentMsg] = useState('');
  const doaDetails = pnqPayload?.doaAssignedToUsers?.length ? pnqPayload?.doaAssignedToUsers[0] : {};
  useEffect(() => {
    if (doaStatus == 'CLARITY_REQUIRED') {
      getHistory();
    }
  }, []);
  useEffect(() => {
    if (remarksError) {
      setshowcomment(true);
    }
  }, [remarksError]);
  const getHistory = () => {
    let params = { doaId: doaId };
    // showLoader(true);
    getClarityHistory(params)
      .then((res) => {
        // showLoader(false);
        res && res.data && res.data.result && setcommenthistory([...res.data.result]);
      })
      .catch((err) => {
        // showLoader(false);
      });
  };

  const commentToggleHandler = () => {
    setshowcomment(!showcomment);
    // setshowbutton(!showbutton);
  };
  const onFileUpload = (e) => {
    e.stopPropagation();
    let { files, name } = e.target;
    if (!files.length) {
      return;
    }
    if (files[0].size > 2097152) {
      if (fileuploadError) {
        fileArray = fileArray.slice(1);
      }
      setfileuploadError(true);
      setfileName('');
      setfileArray([
        {
          name: files[0].name,
          file: '',
          success: false,
          error: true
        },
        ...fileArray
      ]);
    } else {
      let reader = new FileReader();
      reader.readAsDataURL(files[0]);
      reader.onload = (e) => {
        if (fileuploadError) {
          setfileArray([
            {
              name: files[0].name,
              file: e.target.result.split(',')[1],
              success: true,
              error: false
            },
            ...fileArray.slice(1)
          ]);
          setfileuploadError(false);
        } else {
          if (name) {
            let foundIndex = fileArray.findIndex((item) => item.name == name);
            fileArray[foundIndex] = {
              name: files[0].name,
              file: e.target.result.split(',')[1],
              success: true,
              error: false
            };
            setfileArray(fileArray);
          } else {
            setfileArray([
              {
                name: files[0].name,
                file: e.target.result.split(',')[1],
                success: true,
                error: false
              },
              ...fileArray
            ]);
          }
        }
      };
    }
  };
  const renderFiles = () =>
    fileArray.length &&
    fileArray.map((item, index) => (
      <React.Fragment>
        {index < 5 && (
          <li className={`${item.success ? 'success' : item.error && 'error'}`}>
            <input type="file" name={item.name} title={item.name} accept="image/*;capture=camera" onChange={(e) => onFileUpload(e)} />
            {item.error && <div className="errorTxt">Error: File size exceeding 2MB.</div>}
          </li>
        )}
      </React.Fragment>
    ));

  const renderHistory = () =>
    commenthistory
      .slice(0)
      .reverse()
      .map((item, index) => (
        <div className="commentcontentbox">
          <div className="triangleleft"></div>
          {/*<span></span>*/}
          <div className="commentcontenthead">
            <div className="doanameNewbadge">
              <div className="doaname">
                {item.assignedToRole && item.assignedToRole}: {item.name && item.name}
              </div>
              {index == 0 && <div className="newBadge">New</div>}
            </div>
            <div className="doabox">
              <p>
                Date of comment:
                {moment(item.requestClosedAt && item.requestClosedAt).format('DD MMMM YYYY')}
              </p>
              <p>Time of comment: {moment(item.requestClosedAt && item.requestClosedAt).format('hh:mm A')}</p>
            </div>
            <div className="doaarea">{item.userRemarks && item.userRemarks}</div>
          </div>
        </div>
      ));

  const arcHandler = (value) => {
    let re = /^([0-9]*){10,}$/;
    if (re.test(value)) {
      setarc(value);
    } else {
      setarc('');
    }
  };
  const otcHandler = (value) => {
    let re = /^([0-9]*){10,}$/;
    if (re.test(value)) {
      setotc(value);
    } else {
      setotc('');
    }
  };
  const setRemarksValue = (value) => {
    setremarks(value);
    setRemarksError(false);
  };

  const contractPeriodHandler = (value) => {
    console.log(value);
    setContractPeriod(value);
  };
  useEffect(() => {
    if (selectedPlan && selectedPlan.price && selectedPlan.price.customPricePlan) {
      setarc(selectedPlan.price.amount);
      setotc(selectedPlan.price.otc);
    } else {
      setarc('');
      setotc('');
    }
    if (pnqPayload && pnqPayload.doaAssignedToRole) {
      let approval = pnqPayload.doaAssignedToRole.replace(/_/g, ' ');
      approval = approval ? approval.toLowerCase() : '';
      setApprovalRequestSentMsg(approval);
      faOnDedicatedKamApprovalOrder();
    }
  }, []);
  let getArc = arc ? parseInt(arc) : 0;
  let getOtc = otc ? parseInt(otc) : 0;
  let contractPeriod = selectedContractPeriod && selectedContractPeriod.value ? selectedContractPeriod.value : selectedContractPeriod;
  let total = (getArc || getOtc) && contractPeriod ? getArc * contractPeriod + getOtc : 0;
  return (
    <div className="orderSection">
      <div className="summaryForms customized">
        <div className="row">
          <div className="flg-sm-12 flg-md-4 flg-lg-4">
            <div className="inputSection">
              <Input
                name="otc"
                type="text"
                label="One Time Charges"
                placeholder="&nbsp;"
                value={otc}
                onChange={(value) => otcHandler(value)}
                errors={[]}
                required
                touched={false}
                autoComplete="off"
              />
            </div>
          </div>
          <div className="flg-sm-12 flg-md-4 flg-lg-4">
            <div className="inputSection">
              <Input name="arc" type="text" label="Recurring Charges" placeholder="&nbsp;" value={arc} character required onChange={(value) => arcHandler(value)} />
            </div>
          </div>
          <div className="flg-sm-12 flg-md-6 flg-lg-4">
            {doaStatus === 'CLARITY_REQUIRED' ? (
              <div className="row">
                <div className="flg-lg-5 flg-sm-12">
                  <Select placeholder="Choose a contract period" value={selectedContractPeriod} onChange={contractPeriodHandler} options={contractPeriodOptions} required touched />
                </div>
              </div>
            ) : (
              <Input
                label="Contract Period"
                value={
                  selectedContractPeriod && selectedContractPeriod.value
                    ? selectedContractPeriod.value === 1
                      ? selectedContractPeriod.value + ' Year'
                      : selectedContractPeriod.value + ' Years'
                    : selectedContractPeriod
                    ? selectedContractPeriod + ' Year'
                    : '1 Year'
                }
                required
                disabled
              />
            )}
          </div>
          <div className="flg-sm-12 flg-md-12 flg-lg-12">
            <div className="charges">
              <p>
                Total Charges
                <span className="wtax"> (without tax)</span>
                <span className="gst">GST rates as applicable</span>
                <span className="gst">*Add CAPEX charges to one-time charge, if applicable. </span>
              </p>
              &#8377;{numberWithCommas(total)}
            </div>
          </div>
        </div>
      </div>
      <div clasName="status">
        <div className=""></div>
      </div>
      {showcomment || (pnqPayload && pnqPayload.leadStatus === 'REQUIRED_PRICE_NEGOTIATION') ? (
        <div className="commentSection">
          <span>Add a comment(if any)</span>
          <p>Please add your comment for customized pricing and add attachments if any.</p>
          <TextArea name="demo" label="Enter Description" placeholder="Enter Description" required value={remarks} onChange={(value) => setRemarksValue(value)} maxLength={150} />
          <div className="characters">&nbsp;</div>
          {remarksError && !remarks && <div className="error">Please enter Description</div>}
          <div className="addAttachments">
            <p>
              Add attachments <span>(Add upto 5 files)</span>
            </p>
            <span>Please note a file size should be less than 2MB.</span>
            <div className="attachmenticon">
              <ul>{renderFiles()}</ul>
            </div>
          </div>
        </div>
      ) : (
        ''
      )}
      {/* <ClarityRequired/> */}

      {doaStatus === 'CLARITY_REQUIRED' ? (
        <div className="doaPricing">
          <h2>DOA Pricing Approval Status</h2>
          <div className="failure">
            <div className="orangestatus">
              <img src={Warning} />
              <p>
                Status:<b>Clarity Required</b>
              </p>
            </div>
          </div>
          {!showcomment ? (
            <div className="addComment">
              <Button variant="transparentbtn" onClick={commentToggleHandler}>
                Add a Comment
              </Button>
            </div>
          ) : (
            ''
          )}
          {commenthistory.length && (
            <React.Fragment>
              <div className="commentHistory" onClick={() => setshowcommenthistory(!showcommenthistory)}>
                <p>view comment history</p>
                <span className="chevron"></span>
              </div>
              <div className="commentdetails">
                {showcommenthistory ? (
                  <div className="containersml">
                    <div className="commentboxes">{renderHistory()}</div>
                  </div>
                ) : (
                  ''
                )}
              </div>
            </React.Fragment>
          )}
        </div>
      ) : (
        ''
      )}

      {pnqPayload && pnqPayload.leadStatus === LEAD_STATUS.PRICING_APPROVAL_REQUEST_SENT && doaStatus !== 'CLARITY_REQUIRED' && (
        <div className="status">
          <div className="success">
            <div className="greenstatus">
              <div className="checkbg">
                <div className="check"></div>
              </div>
              {pnqPayload && pnqPayload.doaAssignedToRole && approvalRequestSentMsg ? (
                <p>
                  {' '}
                  Your request has been sent successfully to{' '}
                  <span className="caps-letter display-inline">
                    {approvalRequestSentMsg}, <span> {doaDetails?.name}</span>(
                    <a className="assistance_link" href={'mailto: ' + doaDetails?.email}>
                      {doaDetails?.email}
                    </a>
                    ,<span> {doaDetails?.phoneNumber})</span>
                  </span>
                  for approval.
                </p>
              ) : (
                getDoaDetailsNotification(doaDetails)
              )}
            </div>
          </div>
        </div>
      )}
      {/*{*/}
      {/*  doaStatus ==="CLARITY_REQUIRED" &&*/}
      {/*    <div className="status">*/}
      {/*      <div className="failure">*/}
      {/*        <div className="orangestatus">*/}
      {/*          <img src={Warning}/>*/}
      {/*          <p>*/}
      {/*            Status: Clarity required.*/}
      {/*          </p>*/}
      {/*        </div>*/}
      {/*      </div>*/}
      {/*    </div>*/}
      {/*}*/}
    </div>
  );
};

export default CustomizedPlan;
